import { css } from 'aphrodite'
import { StyleSheet } from 'aphrodite'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import LoadCard from '../components/LoadCard'
import LoadTable from '../components/LoadTable'
import SubmitButton from '../components/SubmitButton'
import TagHeader from '../components/TagHeader'
import { useTagContext } from '../contexts/TagContext'
import { type LoadResponse, loadService } from '../services/loadService'
import { loadDashboardStyles } from './LoadDashboard'

const LoadConfirmation: React.FC = () => {
  const { tagId } = useParams()
  const navigate = useNavigate()
  const [loads, setLoads] = useState<LoadResponse[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const { tags, getCurrentTag } = useTagContext()

  const currentTag = getCurrentTag(tagId)

  useEffect(() => {
    const fetchLoads = async () => {
      if (tagId) {
        try {
          const loadData = await loadService.getLoadsByTag(tagId)
          setLoads(loadData)
        } catch (error) {
          console.error('Failed to load data:', error)
        }
      }
      setIsLoading(false)
    }

    fetchLoads()
  }, [tagId])

  const handleEditLoad = (loadNumber: number, loadId: number) => {
    if (tagId) {
      navigate(`/tags/open/${tagId}/${loadNumber}/details`, {
        state: { loadId },
      })
    }
  }

  if (isLoading) {
    return (
      <div className={css(loadDashboardStyles.pageContainer)}>
        <TagHeader
          tagId={tagId}
          title="Confirmation page"
          status={currentTag?.status || 'IN_PROGRESS'}
          showAdditionalExpenses={true}
        />
        <div>Loading...</div>
      </div>
    )
  }

  return (
    <div className={css(loadDashboardStyles.pageContainer)}>
      <TagHeader
        tagId={tagId}
        title="Site confirmation"
        initialIsExpanded={true}
        isDetailed={true}
        status={currentTag?.status || 'IN_PROGRESS'}
        showAdditionalExpenses={true}
      />
      <div className={css(loadDashboardStyles.tableSection)}>
        {tagId && <LoadTable tagId={tagId} />}
      </div>
      <div className={css(styles.submitButtonContainer)}>
        <SubmitButton
          canSubmit={true}
          text="Accept & Sign"
          onClick={() =>
            navigate(`/tags/open/${tagId}/loads/confirmation/sign`)
          }
        />
      </div>
      <div className={css(styles.bottomSpacer)} />
    </div>
  )
}

const styles = StyleSheet.create({
  submitButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
    width: '100%',
  },
  bottomSpacer: {
    height: '80px', // Adds significant space at the bottom
    width: '100%',
  },
})

export default LoadConfirmation
